import ContactFooter from "./ContactFooter";
import HtmlRenderer from "./HtmlRenderer";
import { useRef } from "react";
import glv from "../utils/getLocalizedValue"

const publicUrl = process.env.PUBLIC_URL || "";

function SimpleContainer({ title, description, children }) {
  return (
    <>
      <section className="font-pretendard flex flex-col mb-10 flex-wrap">
        <div className="f-20 font-[700] mb-2">
          <h2>
            <HtmlRenderer
              htmlString={title}
            />
          </h2>
        </div>
        <HtmlRenderer
          htmlString={description}
          className="f-20 font-[300] tracking-[-0.015em] flex flex-wrap"
        />
        {children && children}
      </section>
    </>
  );
}

function ContactPage() {
  let contactRef = useRef(null);
  return (
    <>
      <div
        className="w-full h-full overflow-y-scroll overflow-x-hidden"
        style={{ scrollSnapType: "y proximity" }}
      >
        <div className="flex flex-col w-full px-5 justify-start items-center py-2 md:py-10 flex-wrap font-pretendard ">
          <div className="flex flex-col max-w-[70rem] w-full">
            <header className="font-[900] mt-5 mb-0 lg:text-3xl md:text-3xl text-3xl text-center">
              <h1>Let’s Keep in Touch!</h1>
            </header>
            <main className="flex flex-col w-full flex-wrap justify-center items-center">
              <img
                src={`${publicUrl}/svg/map.svg`}
                alt=""
                className="w-full max-w-[80rem] my-[5rem] h-auto"
              />
              <div className="flex max-w-[50rem] w-full sm:flex-row flex-col font-pretendard pt-10 border-t-[1px] border-b-[1px] mb-10 border-brand-steel-grey">
                <div className="me-5">
                  <SimpleContainer
                    title="Headquarter 🇰🇷"
                    description={glv("2nd Floor, 99 Daehak-ro, Yuseong-gu<br/>Daejeon, South Korea (34134) ","대전광역시 유성구 대학로 99,<br/> (궁동) 팁스타운 2층 (34134)")}
                  />
                  <SimpleContainer
                    title="R&D Center 🇰🇷"
                    description={glv("2624, Geumgang Penterium IX Tower A, 27, Dongtancheomdansaneop 1-ro,<br/>Dongtan-gu, Hwaseong-si, <br/>Gyeonggi-do, South Korea <br/>(18469)","경기도 화성시 동탄첨단산업1로 27,<br/> A동 2624호(영천동, 금강펜테리움IX타워) <br/>(18469)")}
                  />
                </div>
                <div>
                  <SimpleContainer
                    title="KSCC us<br><span class='text-base'>(KoolMicro Sillicon Valley Customer Center)</span>"
                    description="3003 North First Street #308,<br/>San Jose CA, United States (95134) "
                  />
                  <SimpleContainer
                    title="KARC us<br><span class='text-base'>(KoolMicro Advanced R&amp;D Center)</span>"
                    description=""
                  />
                </div>
              </div>
              <div className="w-full sm:flex-row flex-col flex justify-center">
                <SimpleContainer
                  title={glv("Phone 📞","전화 📞")}
                  description="+82) 42-721-0214"
                />
                <div className="sm:mx-[6rem]">
                  <SimpleContainer
                    title={glv("Email ✉","이메일 ✉")}
                    description="<a href='mailto:info@koolmicro.com'>info@koolmicro.com</a>"
                  />
                </div>
                <SimpleContainer
                  title={glv("Social","소셜")}
                  description=""
                  children={
                    <>
                      <div className="flex mt-5 items-center">
                        <a
                          href="https://www.youtube.com/@KoolMicro"
                          className="block"
                        >
                          <img
                            className="h-[1.2rem]"
                            src={require("../assets/icon/youtube.png")}
                            alt=""
                          />
                        </a>
                        <a
                          className="ms-4 block"
                          href="https://www.linkedin.com/company/koolmicro/posts/?feedView=all"
                        >
                          <img
                            className="h-[1.3rem]"
                            src={require("../assets/icon/linkedin.png")}
                            alt=""
                          />
                        </a>
                      </div>
                    </>
                  }
                />
              </div>
            </main>
          </div>
          <div className=" md:mt-10 mt-2 text-center font-[300] lg:text-xl md:text-lg hover:scale-110 transition-transform duration-300">
            <button
              onClick={() => {
                const contact = contactRef.current;
                if (contact) {
                  contact.scrollIntoView({
                    behavior: "smooth",
                    block: "center",
                  });
                }
              }}
            >
              {glv("Or simply submit the form down below:","아래 양식을 통해서도 연락하실 수 있습니다! ")}
              <br />↓
            </button>
          </div>
        </div>
        <div className="" ref={contactRef}>
          <ContactFooter />
        </div>
      </div>
    </>
  );
}

export default ContactPage;
